import AboutUsPage from "./AboutUsPage";

export default AboutUsPage;